// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","title":"title-2OlFj","content":"content-2U-NR","upsaleItem":"upsaleItem-y7KP9"};